<template>
  <div class="#app">
     <router-view v-if="!$route.meta.keepAlive">
      <!-- 这里是不被缓存的视图组件，比如 Edit！ -->
      </router-view>
      <mt-popup v-model="popupVisible2" position="top" class="mint-popup-2" :modal="false" id="popup" onclick="goTwo(response)" >
        <img src="@/assets/images/icon.png" alt="">
          <span class="shopName" id="type">卡逸客</span> <br>
          <span class="tongzhi"  id="tongzhi">tongzhi</span>   
      </mt-popup>
      <!-- <div id="active">显示</div> -->
  </div>
</template>

<script>
import store from "@/vuex/store";
import { mapState } from "vuex";
import { Popup , Toast} from 'mint-ui';
import { loginWithSession } from '@/assets/js/lifeCycle'

export default {
  name: 'App',
  data(){
    return{
      popupVisible2:false,
        showPositionValue: false, //是否显示提示
              position: 'center', //提示信息的位置
              toastText: '', // 提示文本
    }
  },
  watch: {
    popupVisible2(val) {
      if (val) {
        setTimeout(() => {
          this.popupVisible2 = false;
        }, 2000);
      }
    }
  },
    components: {
          Toast
      },
  methods:{
    NotifyNewMessage(){

    },
    goTwo(){
      console.log(11111111)
    },
    onGetSucc(obj)
    {
    },
    onGetError(obj)
    {
    }
  },
  beforeCreate () {
    loginWithSession(() => {
      this.$router.push({ name: "cardBag" })
    }, () => {
      this.$router.push({ name: "indexOne" })
    })
  },
  beforeRouteLeave (to, from, next) {
    console.log(this)
  }
}

</script> 

<style   scoped>
#active{ 
  max-width: 6rem;
  height: 1.5rem;
  color: white;
  font-size: 0.6rem;
  text-align: center;

  background: rgba(0,0,0,.7)

}
.mint-toast{
  width: 6rem !important
}
  .mint-popup-2 {
        width: 100%;
        height:1.5rem;

        background-color: rgba(0,0,0,.7);
        backface-visibility: hidden;
      }
    .mint-popup-2 p {
        line-height: 50px;
        color: #fff;
      }
        img{
          height: 1.2rem;
          width: 1.2rem;
          position:relative;
          top: 50%;
          margin-top: -0.6rem;
          margin-left: 0.6rem;
          
        }
        .content{
          display: inline-block
        }
        .shopName{
           font-size: 0.5rem;
           color:white ;
           vertical-align: middle;
           margin-left: 0.3rem
                   }
        .tongzhi{
          vertical-align: middle;
          margin-left: 2.3rem;
          color: rgba(255,255,255,.4)
        }
        .time{
          font-size: 0.4rem;
          margin-left:2.5rem;
          color: rgba(255,255,255,.4);
          position:relative;
          top: -20%
        }
</style>



// WEBPACK FOOTER //
// src/App.vue